export default {
  passed: 'Passed',
  production: 'Production'
}
